import { z } from 'zod';

export const get = async (): Promise<User> => {
	const response = await fetch('/home');
	return await response.json();
};

export const UserSchema = z.object({
	id: z.number().nullable(),

	// * Manged over pips
	geoveraAccess: z.boolean().nullable(),
	geoveraLockboxes: z.string().nullable(),

	wellsFargoAccess: z.boolean().nullable(),
	wellsFargoLockboxes: z.string().nullable(),

	speedbuilderAccess: z.boolean().nullable(),
	northlightAccess: z.boolean().nullable(),
	northlightRenewalAccess: z.boolean().nullable(),
	commissionStatementAccess: z.boolean().nullable(),
	dbStatementUploadAccess: z.boolean().nullable(),
	directBillAccess: z.boolean().nullable(),

	// * Azure Groups
	dex360AuditAccess: z.boolean().nullable(),
	blacklineAccess: z.boolean().nullable(),
	blacklineBillingAccess: z.boolean().nullable(),
	fireballAdminAccess: z.boolean().nullable(),
	accountingAccess: z.boolean().nullable(),
});

export type User = z.infer<typeof UserSchema>;
